import { useState } from "react";
import Card from "../../components/card/card.component";
import { NavLink } from "../../components/navbar/navbar.component";
import "./case-study.component.css";
import LotionPhoto from "../../assets/lotion.png";
import BerryPhoto from "../../assets/berry.png";
import UIhoto from "../../assets/UI.png";

function CaseStudy() {
  // eslint-disable-next-line no-unused-vars
  const [caseStudies, setCaseStudies] = useState([
    {
      photo: LotionPhoto,
      heading: "SkinLux",
      subHeading: "Skincare & Beauty App",
      isBtnDark: true,
      link: "https://www.figma.com/proto/sdkms2OJhOiWwedTbZRkyJ/TSHEPISO-PORTFOLIO?page-id=1125%3A35&node-id=1125-36&t=K5sMadXFLtVhIw08-1",
    },
    {
      photo: BerryPhoto,
      heading: "Fruity",
      subHeading: "Homemade Juice Website",
      isBtnDark: true,
      link: "https://www.figma.com/proto/RHFICjPYYzaCD28DH163gv/Fruity-website?page-id=180%3A44&node-id=287-2&p=f&viewport=-8290%2C453%2C0.3&t=OtelnL5JMz7V27Ta-1&scaling=contain&content-scaling=fixed",
    },
    {
      photo: UIhoto,
      heading: "UI Design",
      subHeading: "User Interfaces",
      isBtnDark: true,
      link: "https://www.figma.com/proto/1H1QOijW2CTRfYHBF5kXgc/Daily-UI-screen-challenges?page-id=159%3A56&node-id=159-57&p=f&viewport=40%2C115%2C0.67&t=K569PIBYRTfbyT2X-1&scaling=min-zoom&content-scaling=fixed",
    },
  ]);
  return (
    <div
      className="page page-padding case-study-page pb-0 d-flex flex-column align-items-center"
      id={NavLink.CASE_STUDY}
    >
      <div className="heading align-self-start padding-v-40 no-padding-top pb-sm-0">
        <div className="font-sub-heading font-bold">Case Study.</div>
      </div>
      <div className="d-flex justify-content-center flex-wrap padding-v-40">
        {caseStudies.map((x, i) => (
          <Card
            photo={x.photo}
            heading={x.heading}
            subheading={x.subHeading}
            btnText={x.btnText}
            isBtnDark={x.isBtnDark}
            onClick={() => {
              if (x.link) {
                window.open(x.link, "_blank");
              }
            }}
            key={i}
          />
        ))}
      </div>
    </div>
  );
}

export default CaseStudy;
